import { ChangeDetectionStrategy, Component } from '@angular/core';
import { TranslocoPipe } from '@jsverse/transloco';

import versionJson from '@connect-services/version.json';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [TranslocoPipe],
    selector: 'app-version',
    template: "{{ 'version' | transloco }} : {{ version ?? '-' }}",
})
export class VersionComponent {
    public readonly version: string | null = versionJson.version ?? null;
}
